import * as Yup from 'yup';

export const CompanyInformationSchema = Yup.object().shape({
    name: Yup.string().required('Company Name is required'),
    timezone: Yup.object().required('Timezone is required'),
    industry: Yup.object().required('Industry is required'),
    entity: Yup.object().required('Entity type is required'),
    line1: Yup.string().required('Address Line 1 is required'),
    line2: Yup.string(),
    city: Yup.string().required('City is required'),
    state: Yup.string().required('State is required'),
    postalCode: Yup.string().required('Postal Code is required'),
    country: Yup.string().required('Country is required'),
});

export const StepOneCompnayInformationInitialValues = (isOnboardingFlow, companyData, data) => {
    return {
        name: isOnboardingFlow ? companyData?.name : data?.name,
        timezone: data?.timezone || {
            label: 'New York (Eastern Time - EST/EDT)',
            value: 'America/New_York',
        },
        industry: isOnboardingFlow ? companyData?.industry : data?.industry,
        entity: isOnboardingFlow 
        ? companyData?.entity 
        : (data?.entity ? {
            label: data.entity,
            value: data.entity
          } : null),
        line1: isOnboardingFlow ? companyData?.address?.line1 : data?.address?.line1,
        line2: isOnboardingFlow ? companyData?.address?.line2 : data?.address?.line2,
        line3: isOnboardingFlow ? companyData?.address?.line3 : data?.address?.line3,
        line4: isOnboardingFlow ? companyData?.address?.line4 : data?.address?.line4,
        line5: isOnboardingFlow ? companyData?.address?.line5 : data?.address?.line5,
        city: isOnboardingFlow ? companyData?.address?.city : data?.address?.city,
        state: isOnboardingFlow ? companyData?.address?.state : data?.address?.state,
        country: isOnboardingFlow ? companyData?.address?.country : data?.address?.country,
        postalCode: isOnboardingFlow
            ? companyData?.address?.postal_code
            : data?.address?.postal_code,
        email: isOnboardingFlow ? companyData?.email : data?.email,
    };
};
